if ($('.grid').length){

    $('.grid').imagesLoaded( function() {
        // init Isotope
        var $grid = $('.grid').isotope({
            itemSelector: '.bio-card',
            percentPosition: true,
            layoutMode: 'fitRows',
        });

        $(function() { // Remove active class on filter navigation
            $(".filter-button-group li a").click(function() {
                $("li a").removeClass("active");
                $(this).addClass("active");
            });
        });

        // On page load
        var target = $(".bio-grid"); // Get full width of container - Right Edge
        var result = target.position().left + target.width();
        // Get left edge of placeholder div
        var placeholderDiv = $( ".bio-placeholder" ).first();
        var position = placeholderDiv.position();
        // Get full height of first bio-card
        var height = $(".bio-card").height()
        // Get Total width Difference
        var totalWidth = 0;
        totalWidth = result - position.left;


        if (position.left == 0){
            var gridHeight = $(".grid").height();
            var removeHeight = $(".bio-placeholder").height();
            var newGridHeight = gridHeight - removeHeight;

            $(".bio-placeholder").hide();
            $(".grid").css({"height":newGridHeight});
        }else{

            $(".bio-placeholder").css({
                "right": "0",
                "width": totalWidth,
                "height" : height
            });
        }


        // filter items on button click
        $('.filter-button-group').on( 'click', 'a', function() {
            $(".bio-placeholder").show();
            $(".bio-placeholder").css({"opactiy": 0,"width" : 0,"animation-name": "none"});

            var filterValue = $(this).attr('data-filter');
            $grid.isotope({ filter: filterValue });

            setTimeout(() => {
                var placeholderDiv = $( ".bio-placeholder" ).first();
                var position = placeholderDiv.position();
                var totalWidth = 0;
                    totalWidth = result - position.left;
                $(".bio-placeholder").css({
                    "right": "0",
                    "width": totalWidth,
                    "height" : height,
                    "animation-name" : "fadeIn",
                    "animation-duration" : "200ms"
                });
            }, 500);
        });
    });
}
else{

}